import { gql } from "lib/apolloClient";

export const getMfaEnforcementQuery = gql`
  query getMfaEnforcedUserTypes($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        mfaPolicies {
          entityType
          entityValue
          isEnabled
          isEnforced
          enforcementDeadline
          defaultGracePeriod
          allowedMfaMethods
          allowBackupCodes
        }
      }
    }
  }
`;

export const getUserMfaStatusQuery = gql`
  query getUserMfaStatus($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        mfaDetails {
          isMfaEnforced
          enforcementDeadline
          allowedMfaMethods
          isMfaEnabled
          isBackupCodeUsedForVerification
          areAnyBackupCodesAvailable
          mfaConfigs {
            id
            method
            isEnabled
            isPrimary
            isMfaSetupInAnotherOrg
            metadata
          }
        }
      }
    }
  }
`;
